import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Home from "../components/home";
import useResponsive from "../hooks/useResponsive";
import { Store } from "../store";
import URI from "urijs";

const HomeWrapper = () => {
  const config = Store.useState(s => s.config);
  const navigate = useNavigate();
  const { isMobile } = useResponsive({ maxWidth: config.eshop.theme.selected.settings?.mobileBreakpoint });
  const currentUri = new URI(location.pathname + location.search + location.hash);

  const [previousPath] = useState(currentUri.search(true).prev || "/");

  const handleExit = () => {
    navigate(previousPath);
  };

  return <Home exit={handleExit} isMobile={isMobile} asPage={true} />;
};

const Route = [{
  path: "/home",
  element: <HomeWrapper />
}];

export default Home;
export { Route, HomeWrapper };
